export const hooks = {
  'Code validated successfully!': 'Código validado exitosamente!',
  'Invalid code!': 'Código inválido!',
};
